import React, { useEffect, useState } from 'react';
import { useMain } from 'src/views/hooks/useMain';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';

const FetchSalesExpenseSummary = ({ applyTrigger, setSummaryDataExport }) => {
  const { activeBranchId, fetchSalesExpenseSummary } = useMain();
  const { filterBy, from, to } = useSelector((state) => state.salesAnalytics);
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const getSummary = async () => {
    if (!activeBranchId || activeBranchId === ":branchId") return;
    
    // Guard: Don't hit API if custom date is selected but no dates are provided
    if (filterBy === 'customDate' && (!from || !to)) return;

    const queryParams = `?filterBy=${filterBy}${from ? `&startDate=${from}` : ''}${to ? `&endDate=${to}` : ''}`;

    try {
      setLoading(true);
      if (setSummaryDataExport) setSummaryDataExport(null);
      setHasFetched(true);
      const res = await fetchSalesExpenseSummary(activeBranchId, queryParams);
      if (res.statusCode === 200) {
        setSummaryData(res.data);
        if (setSummaryDataExport) {
          setSummaryDataExport(res.data);
        }
      }
    } catch (error) {
      console.error('Error fetching sales expense summary:', error);
      if (setSummaryDataExport) setSummaryDataExport(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSummary();
  }, [activeBranchId, applyTrigger]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}><ShowLoader /></Box>;
  if (!loading && hasFetched && !summaryData) {
    return <p style={{ marginTop: '2rem' }}>No bills are available for the selected time interval.</p>;
  }
  if (!summaryData) return null;

  return (
    <Box sx={{ mb: 4, mt: 2 }}>
      <table className="table-container mt-3">
        <thead className="table-thead">
          <tr>
            <th style={{ minWidth: '120px' ,  textAlign: 'center' }}>Date</th>
            <th style={{ width: '100%' ,  textAlign: 'center' }}>Total Sales</th>
            <th style={{ width: '100%' ,  textAlign: 'center' }}>Total Expense</th>
            <th style={{ width: '100%' ,  textAlign: 'center' }}>Net Sales</th>
          </tr>
        </thead>
        <tbody className="table-tbody">
          {summaryData.dailySummary && summaryData.dailySummary.length > 0 ? (
            summaryData.dailySummary
              .map((item, index) => {
                const [year, month, day] = item.date.split('-');
                const formattedDate = `${day} ${month} ${year}`;
                return (
                   <tr key={index}>
                    <td style={{ minWidth: '120px' , textAlign: 'center' }}>{formattedDate}</td>
                    <td style={{ width: '100%' , textAlign: 'center' }}>₹{item.totalSales.toLocaleString('en-IN')}</td>
                    <td style={{ width: '100%' , textAlign: 'center' }}>₹{item.totalExpense.toLocaleString('en-IN')}</td>
                    <td
                      style={{
                        width: '100%',
                        fontWeight: 600,
                        color: item.netSales >= 0 ? '#03C4A9' : '#F44336',
                        textAlign: 'center',
                      }}
                    >
                      ₹{item.netSales.toLocaleString('en-IN')}
                    </td>
                  </tr>
                );
              })
          ) : (
            <tr key="no-transactions">
              <td colSpan="4" style={{ textAlign: 'center', width: '100%' }}>
                No transactions found for this period.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default FetchSalesExpenseSummary;